export default {
    data() {
        return {
            isGameInfoEnter: null
        }
    },
    methods: {
        moveGame(val) {
            this.isGameInfoEnter = val
            window.addEventListener('keypress', this.getKeypress)
        },
        getKeypress(e) {
            if (e.keyCode === 32) {
                this.openGame(this.isGameInfoEnter)
            }
        },
        outGame() {
            this.isGameInfoEnter = null
            window.removeEventListener('keypress', this.getKeypress)
        },
        // 打开游戏
        openGame(val) {
            if (!this.isLogin) {
                this.openLoginPop();
                return;
            }
            this.$loading.show();
            const params = {
                platType: val.platType,
                gameType: val.gameType,
                gameCode: val.gameCode,
                devices: 0,
            };
            this.$Api.getGameUrl(params).then((res) => {
                if (res) {
                    this.$loading.hide();
                    const url = JSON.parse(res.data);
                    window.open(url.url, "_blank");
                }
            });
        },
    }
}